var map = {
  "./_example/templates": "8912",
  "./config/templates": "56499",
  "./frontend/templates": "22685",
  "./help/templates": "85642",
  "./job/templates": "34330",
  "./modules/fulltext/templates": "83633",
  "./modules/gndo/templates": "39111",
  "./modules/presentation/templates": "14127",
  "./modules/qa/templates": "67521",
  "./modules/serverlog/templates": "78812",
  "./modules/stats/templates": "55220",
  "./modules/timeline/templates": "67900",
  "./widgets/templates": "88300",
  "./wiki/templates": "40749"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_date-fns_esm_differenceInYears_index_js-node_modules_date-fns_esm_getDat-803fb0"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 56091;
module.exports = __rspack_async_context;
